import React from 'react';
import { BaseButton } from '../button';

type Props = {
    submitCount?: number;
    isValid?: boolean;
    errors?: any;
    messages?: string[];
    /** Adds a Retry button (direct messages mode) for errors the user can resolve by asking again. */
    onRetry?: () => void;
};

function listErrors(errs: any): string[] {
    if (!errs) return [];
    const out: string[] = [];
    const walk = (obj: any) => {
        if (!obj) return;
        if (typeof obj === 'string') { out.push(obj); return; }
        if (Array.isArray(obj)) { obj.forEach(walk); return; }
        if (typeof obj === 'object') { Object.values(obj).forEach(walk); }
    };
    walk(errs);
    return Array.from(new Set(out));
}

export const FormErrorBanner: React.FunctionComponent<Props> = ({ submitCount, isValid, errors, messages, onRetry }) => {
    // Direct messages mode (e.g., cross-form or store-level errors)
    if (Array.isArray(messages) && messages.length > 0) {
        return (
            <div style={{ background: '#fdecea', color: '#611a15', border: '1px solid #f5c2c0', borderRadius: 4, padding: '8px 12px', marginBottom: 12 }}>
                <strong>Please fix the following:</strong>
                <ul style={{ margin: '6px 0 0 16px' }}>
                    {messages.map((e, i) => (
                        <li key={i}>{e}</li>
                    ))}
                </ul>
                {onRetry && (
                    <div style={{ marginTop: 8 }}>
                        <BaseButton variant="outlined" size="compact" onClick={onRetry}>
                            Retry
                        </BaseButton>
                    </div>
                )}
            </div>
        );
    }
    // Formik-driven mode
    if (!submitCount || submitCount <= 0 || !!isValid) return null;
    const derived = listErrors(errors);
    if (!derived.length) return null;
    return (
        <div style={{ background: '#fdecea', color: '#611a15', border: '1px solid #f5c2c0', borderRadius: 4, padding: '8px 12px', marginBottom: 12 }}>
            <strong>Please fix the following:</strong>
            <ul style={{ margin: '6px 0 0 16px' }}>
                {derived.map((e, i) => (
                    <li key={i}>{e}</li>
                ))}
            </ul>
        </div>
    );
};

export default FormErrorBanner;


